export const TenderData = [
  {
    "key": "T83",
    "eventName": "tenders",
    "date": "24 सितंबर 2026",
    "expiryDate": "25 सितंबर 2026",
    "name": "बिहार राज्य खेल प्राधिकरण हेतु स्पोर्ट्स साइंस उपकरणों की आपूर्ति के लिए आरएफपी की प्री-बिड सूचना",
    "corrigendum": "",
    "url": "pdf/notices/pre-bid-notice-related-to-rfp-for-supply-of-sports-science-equipment-for-bihar-state-sports-authority.pdf"
  },
  {
    "key": "T82",
    "eventName": "tenders",
    "date": "09 सितंबर 2026",
    "expiryDate": "8 अक्टूबर 2026",
    "name": "बिहार राज्य खेल प्राधिकरण के लिए स्पोर्ट्स साइंस उपकरण की आपूर्ति हेतु RFP (RFP संख्या BSSA/Tender/Sports Science/26-27/Phase-1/4125 (PR संख्या 011321 (B&C) 2026-27))",
    "corrigendum": "",
    "url": "pdf/notices/BSSA-SPORTS-SCIENCE-TENDER-FULL-DETAILS-PHASE-01.pdf"
  },
  {
    "key": "T81",
    "eventName": "tenders",
    "date": "17 अगस्त 2026",
    "expiryDate": "17 अगस्त 2026",
    "name": "बिहार राज्य खेल प्राधिकरण हेतु खेल विज्ञान उपकरणों की आपूर्ति के लिए निविदा (RFP), आरएफपी संख्या : BSSA/Tender/25-26/3359/26  को रद्द करने से संबंधित सूचना।",
    "corrigendum": "",
    "url": "pdf/notices/sports-science-tender-cancel.pdf"
  },
  {
    "key": "T80",
    "eventName": "tenders",
    "date": "6 अगस्त 2026",
    "expiryDate": "17 अगस्त 2026",
    "name": "प्री-बीड बैठक से संबंधित सूचना आरएफपी संख्या : BSSA/Tender/25-26/3359/26",
    "corrigendum": "",
    "url": "/pdf/notices/L.No-3643.pdf"
  },
  {
    "key": "T79",
    "eventName": "tenders",
    "date": "14 जुलाई 2026",
    "expiryDate": "17 अगस्त 2026",
    "name": "बिहार राज्य खेल प्राधिकरण हेतु खेल विज्ञान उपकरणों की आपूर्ति के लिए निविदा (RFP), आरएफपी संख्या : BSSA/Tender/25-26/3359/26",
    "corrigendum": "",
    "url": "/pdf/notices/sports-science-tender-full-details.pdf"
  },
  {
    "key": "T78",
    "eventName": "tenders",
    "date": "10 जून 2026",
    "expiryDate": "",
    "name": "राज्य खेल अकादमी, राजगीर में 02 वर्षों की अवधि हेतु कैटरिंग एजेंसी के चयन के संबंध में निविदा निरस्तीकरण सूचना आरएफपी सं.: SSA/Tender/26-27/Catering/212 (PR No. 002195 (B&C) 26-27)",
    "corrigendum": "",
    "url": "/pdf/notices/Canceletion-Mess-Tendar.pdf"
  },
  {
    "key": "T77",
    "eventName": "tenders",
    "date": "8 जून 2026",
    "expiryDate": "15 जून 2026",
    "name": "राज्य खेल अकादमी, राजगीर में 02 वर्षों की अवधि हेतु कैटरिंग एजेंसी के चयन के लिए निविदा जमा करने एवं तकनीकी निविदा खुलने की तिथि विस्तारित करने से संबंधित  सूचना (RFP No: SSA/TENDER/26-27/CATERING/212) (PR No. 002195 (B&C) 2026-27)",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/Notices.pdf"
  },
  {
    "key": "T76",
    "eventName": "tenders",
    "date": "26 मई 2026",
    "expiryDate": "",
    "name": "शुद्धिपत्र - 01 राज्य खेल अकादमी, राजगीर में 02 वर्ष की अवधि के लिए कैटरिंग एजेंसी की नियुक्ति, आरएफपी संख्या: एसएसए/निविदा/26-27/कैटरिंग/212 (पीआर नं.) 002195 (बी एवं सी) 2026-27",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/Corrigendum-01.pdf"
  },
  {
    "key": "T75",
    "eventName": "tenders",
    "date": "13 मई 2026",
    "expiryDate": "20 मई 2026",
    "name": "बिहार राज्य खेल प्राधिकरण, पटना द्वारा प्रकाशित SUPPLY, INSTALLATION, TESTING & COMMISSIONING OF FIREWALL FOR BIHAR STATE SPORTS AUTHORITY, RFP No. BSSA/Tender/25-26/Firewall/1/1992 (PR. No. 000813 (B&C) 2026-27) से संबंधित निविदा की तकनीकी निविदा में सफल/असफल फर्मों की सूची एवं वित्तीय निविदा खोलने से संबंधित सूचना।",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/notice-for-financial-bid-opening.pdf"
  },
  {
    "key": "T74",
    "eventName": "tenders",
    "date": "07 मई 2026",
    "expiryDate": "11 मई 2026",
    "name": "शुद्धिपत्र - 01 बिहार राज्य खेल प्राधिकरण के लिए फायरवॉल की आपूर्ति, स्थापना, परीक्षण और कमीशनिंग।आरएफपी संख्या: BSSA/Tender/25-26/Firewall/1/1992 (पीआर संख्या 000813 (B&C) 2026-27)",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/fyrewall.pdf"
  },
  {
    "key": "T73",
    "eventName": "tenders",
    "date": "30 अप्रैल 2026",
    "expiryDate": "8 जून 2026",
    "name": "राज्य खेल अकादमी, राजगीर में 02 वर्ष की अवधि के लिए कैटरिंग एजेंसी की नियुक्ति, आरएफपी संख्या: एसएसए/निविदा/26-27/कैटरिंग/212 (पीआर नं.) 002195 (बी एवं सी) 2026-27",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/RFPforMESSFullPDF.pdf"
  },
  {
    "key": "T72",
    "eventName": "tenders",
    "date": "30 अप्रैल 2026",
    "expiryDate": "8 मई 2026",
    "name": "वित्तीय निविदा खोलने की सूचनाआरएफपी संख्या: BSSA, अल्पकालिक निविदा, 24-25, इलेक्ट्रिकल आइटम, 1710 (पीआर संख्या 27143 B&C) 2025-26",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/electrycal.pdf"
  },
  {
    "key": "T71",
    "eventName": "tenders",
    "date": "30 अप्रैल 2026",
    "expiryDate": "8 मई 2026",
    "name": "वित्तीय निविदा खोलने की सूचना (Financial Bid Opening Notice)आरएफपी संख्या (RFP No.): बी.एस.एस.ए. (BSSA), अल्पकालीन निविदा (Short Tender), 25-26विषय: फर्नीचर आइटम, 1739 (पी.आर. संख्या 27162 बी एंड सी) 2025-26",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/furnyture.pdf"
  },
  {
    "key": "T70",
    "eventName": "tenders",
    "date": "15 अप्रैल 2026",
    "expiryDate": "17 अप्रैल 2026",
    "name": "शुद्धिपत्र - 02 - बिहार राज्य खेल प्राधिकरण हेतु फर्नीचर सामग्री के लिए 03 वर्षों की अवधि के लिए दर अनुबंध (Rate Contract) की स्थापना",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/furniture.pdf"
  },
  {
    "key": "T69",
    "eventName": "tenders",
    "date": "15 अप्रैल 2026",
    "expiryDate": "17 अप्रैल 2026",
    "name": "शुद्धिपत्र - 02 - बिहार राज्य खेल प्राधिकरण हेतु विद्युत सामग्री के लिए 03 वर्षों की अवधि के लिए दर अनुबंध (Rate Contract) की स्थापना",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/electrical.pdf"
  },
  {
    "key": "T68",
    "eventName": "tenders",
    "date": "14 अप्रैल 2026",
    "expiryDate": "08 मई 2026",
    "name": "बिहार राज्य खेल प्राधिकरण के लिए फायरवॉल की आपूर्ति, स्थापना, परीक्षण और कमीशनिंग हेतु निविदा आमंत्रण",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/firewall.pdf"
  },
  {
    "key": "T67",
    "eventName": "tenders",
    "date": "10 अप्रैल 2026",
    "expiryDate": "15 अप्रैल 2026",
    "name": "शुद्धिपत्र - 01 - बिहार राज्य खेल प्राधिकरण हेतु विद्युत सामग्री के लिए 03 वर्षों की अवधि के लिए दर अनुबंध (Rate Contract) की स्थापना",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/letter-no-1990.pdf"
  },
  {
    "key": "T66",
    "eventName": "tenders",
    "date": "10 अप्रैल 2026",
    "expiryDate": "15 अप्रैल 2026",
    "name": "शुद्धिपत्र - 01 - बिहार राज्य खेल प्राधिकरण हेतु फर्नीचर सामग्री के लिए 03 वर्षों की अवधि के लिए दर अनुबंध (Rate Contract) की स्थापना",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/letter-no-1991.pdf"
  },
  {
    "key": "T65",
    "eventName": "tenders",
    "date": "1 अप्रैल 2026",
    "expiryDate": "",
    "name": "बिहार राज्य खेल प्राधिकरण के लिए 03 (तीन) वर्षों की अवधि हेतु इवेंट मैनेजमेंट एवं ऑपरेशन्स के लिए एजेंसियों के एम्पैनलमेंट से संबंधित RFP No. BSSA/Tender/25-26/EMA-01/6350 PR No. 019456 (B&C) 25-26 से संबंधित सूचीबद्ध होनवाले फर्मों की सूची",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/listOfEmanelledAgenciesOfBiharStateSportsAuthority.pdf"
  },
  {
    "key": "T64",
    "eventName": "tenders",
    "date": "24 मार्च 2026",
    "expiryDate": "10 अप्रैल 2026",
    "name": "बिहार राज्य खेल प्राधिकरण हेतु फर्नीचर सामग्री के लिए 03 वर्षों की अवधि के लिए दर अनुबंध (Rate Contract) की स्थापना",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/BSSA-SHORT-TENDER-FOR-FURNITURE-ITEM-PDF.pdf"
  },
  {
    "key": "T63",
    "eventName": "tenders",
    "date": "23 मार्च 2026",
    "expiryDate": "10 अप्रैल 2026",
    "name": "बिहार राज्य खेल प्राधिकरण हेतु विद्युत सामग्री के लिए 03 वर्षों की अवधि के लिए दर अनुबंध (Rate Contract) की स्थापना",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/134187299269238739.pdf"
  },
  {
    "key": "T62",
    "eventName": "tenders",
    "date": "20 फरवरी 2026",
    "expiryDate": "16 मार्च 2026",
    "name": "राज्य खेल अकादमी, राजगीर में 03 वर्ष की अवधि के लिए वॉच एंड वार्ड सुरक्षा पर्यवेक्षक और सुरक्षा गार्ड प्रदान करने के लिए सुरक्षा एजेंसी की नियुक्ति, आरएफपी संख्या एसएसए/निविदा/25-26/सुरक्षा-आरएससी/170 (दूसरी कॉल) पीआर संख्या 015453 (बी एवं सी)",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/corrigendum-for-ssa-Tender.pdf"
  },
  {
    "key": "T61",
    "eventName": "tenders",
    "date": "23 फरवरी 2026",
    "expiryDate": "",
    "name": "बिहार राज्य खेल प्राधिकरण के लिए 03 (तीन) वर्षों की अवधि हेतु इवेंट मैनेजमेंट एवं ऑपरेशन्स के लिए एजेंसियों के एम्पैनलमेंट से संबंधित RFP No. BSSA/Tender/25-26/EMA-01/6350 PR No. 019456 (B&C) 25-26 से संबंधित निविदा की तकनीकी दस्तावेज़ों एवं तकनीकी प्रस्तुतीकरण के परीक्षण के उपरांत अंतिम रूप से सफल एवं असफल फर्मों की सूची।",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/accepted-tenders.pdf"
  },
  {
    "key": "T60",
    "eventName": "tenders",
    "date": "20 फरवरी 2026",
    "expiryDate": "27 फरवरी 2026",
    "name": "खुशी कुमारी सक्षम योजना के अंतर्गत खेल उपकरणों की क्रय से संबंधित कोटेशन की मांग",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/khushi-kumari-quation-weightlifting.pdf"
  },
  {
    "key": "T59",
    "eventName": "tenders",
    "date": "20 फरवरी 2026",
    "expiryDate": "27 फरवरी 2026",
    "name": "Eklavya कुश्ती खेल उपकरण हेतु कोटेशन की मांग",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/kushti-quation.pdf"
  },
  // {
  //   "key": "T58",
  //   "eventName": "tenders",
  //   "date": "20 फरवरी 2026",
  //   "expiryDate": "27 फरवरी 2026",
  //   "name": "Ekalavya केंद्र हेतु उपकरण क्रय खेल विधा भारोत्तोलन कोटेशन की मांग",
  //   "corrigendum": "",
  //   // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
  //   "url": "/pdf/notices/weighlifting-quation.pdf"
  // },
  {
    "key": "T57",
    "eventName": "tenders",
    "date": "11 फरवरी 2026",
    "expiryDate": "",
    "name": "बिहार स्टेट स्पोर्ट्स अथॉरिटी के इवेंट मैनेजमेंट और ऑपरेशन्स के लिए एजेंसियों के काम के लिए 03 साल के समय के लिए एम्पैनलमेंट के लिए बिडर्स की रिजेक्शन लिस्ट RFP नंबर: BSSA/टेंडर/25-26/EMA -01/6350 PR नंबर 019456 (B&C) 25-26",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/rejected-tenders.pdf"
  },
  {
    "key": "T56",
    "eventName": "tenders",
    "date": "19 फरवरी 2026",
    "expiryDate": "26 फरवरी 2026",
    "name": "सक्षम छात्रवृत्ति योजना के आकाश कुमार को खेल सामाग्री क्रय करने हेतु कोटेशन की माँग के सम्बंध में",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/akash-kushti.pdf"
  },
  {
    "key": "T55",
    "eventName": "tenders",
    "date": "18 फरवरी 2026",
    "expiryDate": "23 फरवरी 2026",
    "name": "एकलव्य प्रशिक्षण केंद्र, बक्सर, बेगूसराय एवं सीतामढ़ी के लिए कबड्डी खेल सामग्रियों के क्रय हेतु कोटेशन की मांग के संबंध में।",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/img/notices/1lavya-kabaddi-tender1.jpeg"
  },
  {
    "key": "T54",
    "eventName": "tenders",
    "date": "10 फरवरी 2026",
    "expiryDate": "27 फरवरी 2026",
    "name": "राज्य खेल अकादमी, राजगीर में 03 वर्ष की अवधि के लिए निगरानी एवं सुरक्षा पर्यवेक्षक और सुरक्षा गार्ड उपलब्ध कराने हेतु सुरक्षा एजेंसी की नियुक्ति। आरएफपी संख्या: एसएसए/निविदा/25-26/सुरक्षा/170/ 2nd Call (पीआर संख्या 023748 (बी एंड सी) 2025-26)",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/security-2nd-call.pdf"
  },
  {
    "key": "T53",
    "eventName": "tenders",
    "date": "11 फरवरी 2026",
    "expiryDate": "16 फरवरी 2026",
    "name": "सक्षम छात्रवृत्ति योजना के अंतर्गत खेल सामाग्री क्रय करने हेतु कोटेशन की माँग के सम्बंध में",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/saksham.pdf"
  },
  {
    "key": "T52",
    "eventName": "tenders",
    "date": "9 फरवरी 2026",
    "expiryDate": "12 फरवरी 2026",
    "name": "खेलों इंडिया स्मॉल सेंटर, फुटबॉल जमूई के खिलाड़ियों के अभ्यास हेतु एक बड़ा मुभेबल गोलपोस्ट एवं एक छोटा गोलपोस्ट के क्रय हेतु कोटेशन की माँग के संबंध में।",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/jamui-football.pdf"
  },
  {
    "key": "T51",
    "eventName": "tenders",
    "date": "6 फरवरी 2026",
    "expiryDate": "9 फरवरी 2026",
    "name": "एकलव्य ताइक्वांडो प्रशिक्षण केंद्र, बेगूसराय के लिए खेल सामग्री के क्रय हेतु कोटेशन की मांग क के सम्बन्ध में।",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/1lavya-taekwando.pdf"
  },
  {
    "key": "T50",
    "eventName": "tenders",
    "date": "5 फरवरी 2026",
    "expiryDate": "10 फरवरी 2026",
    "name": "एकलव्य राज्य आवासीय तीरंदाजी खेल प्रशिक्षण केन्द्र, प्रशिक्षणरत खिलाड़ियों हेतु खेल उपकरणों का क्रय कर उपलब्ध कराने हेतु कोटेशन की मांग के संबंध में।",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/img/notices/1lavya-archery-2.jpeg"
  },
  {
    "key": "T49",
    "eventName": "tenders",
    "date": "5 फरवरी 2026",
    "expiryDate": "10 फरवरी 2026",
    "name": "एकलव्य राज्य आवासीय तीरंदाजी खेल प्रशिक्षण केन्द्र, प्रशिक्षणरत खिलाड़ियों हेतु खेल उपकरणों का क्रय कर उपलब्ध कराने हेतु कोटेशन की मांग के संबध में",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/img/notices/1lavya-archery-1.jpeg"
  },
  {
    "key": "T48",
    "eventName": "tenders",
    "date": "2 फरवरी 2026",
    "expiryDate": "5 फरवरी 2026",
    "name": "एकलव्य प्रशिक्षण केन्द्र, फुटबॉल हेतु खेल उपकरण के क्रय हेतु कोटेशन की माँग के संबंध में।",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/1lavya-football-quotation.pdf"
  },
  {
    "key": "T47",
    "eventName": "tenders",
    "date": "20 जनवरी 2026",
    "expiryDate": "2 फरवरी 2026",
    "name": "एकलव्य प्रशिक्षण केन्द्र, फुटबॉल हेतु खेल कीट एवं उपकरण के क्रय हेतु कोटेशन की माँग के संबंध में।",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/1lavya-football-tender.pdf"
  },
  {
    "key": "T46",
    "eventName": "tenders",
    "date": "22 जनवरी 2026",
    "expiryDate": "27 जनवरी 2026",
    "name": "एकलव्य कबड्डी प्रशिक्षण केंद्र, बक्सर एवं सीतामढ़ी के लिए कबड्डी खेल सामग्रियों के क्रय हेतु कोटेशन की मांग के संबंध में।",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/img/notices/1lavya-kabaddi-tender.jpeg"
  },
  {
    "key": "T45",
    "eventName": "tenders",
    "date": "13 जनवरी 2026",
    "expiryDate": "20 जनवरी 2026",
    "name": "एकलव्य राज्य आवासीय प्रशिक्षण केन्द्र तीरंदाजी खेल विधा से संबंधित खेल उपकरणों का कोटेशन उपलब्ध कराने के संबध में",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/Quotation Demand for Archery Eklavya.pdf"
  },
  {
    "key": "T44",
    "eventName": "tenders",
    "date": "13 जनवरी 2026",
    "expiryDate": "15 जनवरी 2026",
    "name": "बॉक्सिंग खेल उपकरण/ किट के क्रय हेतु कोटेशन की मांग के संबंध में।",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/img/notices/boxing-equipments.jpeg"
  },
  {
    "key": "T43",
    "eventName": "tenders",
    "date": "7 जनवरी 2026",
    "expiryDate": "8 जनवरी 2026",
    "name": "पारा एथलेटिक्स खेल विधा हेतु खेल उपकरण एवं खेल सामग्री के क्रय हेतू कोटेशन की मॉंग के संबंध में।",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/para-athletics.pdf"
  },
  {
    "key": "T42",
    "eventName": "tenders",
    "date": "7 जनवरी 2026",
    "expiryDate": "19 जनवरी 2026",
    "name": "शुद्धिपत्र - 01 - 03 वर्ष की अवधि के लिए बिहार राज्य खेल प्राधिकरण के लिए इवेंट प्रबंधन और संचालन के लिए एजेंसियों का पैनलीकरण  (RFP No.: BSSA/Tender/25-26/EMA -01/6350  PR No. 019456 (B&C) 25-26)",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/ACE Scanner_2026_01_07.pdf"
  },
  {
    "key": "T41",
    "eventName": "tenders",
    "date": "23 दिसंबर 2025",
    "expiryDate": "27 दिसंबर 2025",
    "name": "फुटबॉल खेल उपकरण के क्रय हेतु कोटेशन की मॉंग के संबंध में ।",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/DOC-20251224-WA0003..pdf"
  },
  {
    "key": "T40",
    "eventName": "tenders",
    "date": "24 दिसंबर 2025",
    "expiryDate": "26 दिसंबर 2025",
    "name": "बैडमिंटन खेल उपकरण के क्रय हेतु कोटेशन की मॉंग के संबंध में ।",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/img/notices/badminton-tender-26-12-2025.jpeg"
  },
  {
    "key": "T39",
    "eventName": "tenders",
    "date": "11 दिसंबर 2025",
    "expiryDate": "13 जनवरी 2026",
    "name": "बिहार राज्य खेल प्राधिकरण के लिए 03 वर्ष की अवधि के लिए इवेंट प्रबंधन और संचालन के लिए एजेंसियों का पैनलीकरण ।",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/BSSA-EMA-TENDER-FULL-DETAILS-PDF.pdf"
  },
  {
    "key": "T38",
    "eventName": "tenders",
    "date": "4 नवंबर 2025",
    "expiryDate": "13 नवंबर 2025",
    "name": "शुद्धिपत्र- 02 - राज्य खेल अकादमी, राजगीर में स्टेडियम, कार्यालय, छात्रावास, बागवानी और अन्य संबद्ध सुविधाओं के लिए 03 की अवधि के लिए व्यापक हाउसकीपिंग, रखरखाव और संचालन (आरएफपी संख्या एसएसए/निविदा/25-26/ओ एंड एम/171 (पीआर संख्या 015463 (बी एंड सी) 2025-26))",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/Scanned_20251107_155619.pdf"
  },
  {
    "key": "T37",
    "eventName": "tenders",
    "date": "3 नवंबर 2025",
    "expiryDate": "13 नवंबर 2025",
    "name": "राज्य खेल अकादमी, राजगीर में स्टेडियम, कार्यालय, छात्रावास, बागवानी और अन्य संबद्ध सुविधाओं के लिए 03 की अवधि के लिए व्यापक हाउसकीपिंग, रखरखाव और संचालन (आरएफपी संख्या एसएसए/निविदा/25-26/ओ एंड एम/171 (पीआर संख्या 015463 (बी एंड सी) 2025-26))",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/img/notices/images/maintain.jpg"
  },
  {
    "key": "T36",
    "eventName": "tenders",
    "date": "3 नवंबर 2025",
    "expiryDate": "13 नवंबर 2025",
    "name": "राज्य खेल अकादमी, राजगीर में 03 वर्ष की अवधि के लिए निगरानी एवं सुरक्षा पर्यवेक्षक और सुरक्षा गार्ड उपलब्ध कराने हेतु सुरक्षा एजेंसी की नियुक्ति। आरएफपी संख्या: एसएसए/निविदा/25-26/सुरक्षा/170 (पीआर संख्या 015453 (बी एंड सी) 2025-26) ",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/img/notices/images/security.jpg"
  },
  {
    "key": "T35",
    "eventName": "tenders",
    "date": "3 नवंबर 2025",
    "expiryDate": "12 नवंबर 2025",
    "name": "राज्य खेल अकादमी, राजगीर में 03 वर्ष की अवधि के लिए व्यापक एएमसी के साथ पूरे परिसर में वाई-फाई समाधान का डिजाइन, आपूर्ति, स्थापना, परीक्षण, कमीशनिंग और रखरखाव RFP No.: SSA/Tender/25-26/WIFI/179  (PR. No. 016464 (B&C) 2025-26",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/img/notices/images/wifi.jpg"
  },
  {
    "key": "T34",
    "eventName": "tenders",
    "date": "24 अक्टूबर 2025",
    "expiryDate": "3 नवंबर 2025",
    "name": "राज्य खेल अकादमी, राजगीर में 03 वर्ष की अवधि के लिए व्यापक एएमसी के साथ पूरे परिसर में वाई-फाई समाधान का डिजाइन, आपूर्ति, स्थापना, परीक्षण, कमीशनिंग और रखरखाव",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/wifi.pdf"
  },
  {
    "key": "T33",
    "eventName": "tenders",
    "date": "16 अक्टूबर 2025",
    "expiryDate": "3 नवंबर 2025",
    "name": "शुद्धिपत्र (1) - राज्य खेल अकादमी, राजगीर में स्टेडियम, कार्यालय, छात्रावास, बागवानी और अन्य संबद्ध सुविधाओं के लिए 03 की अवधि के लिए व्यापक हाउसकीपिंग, रखरखाव और संचालन (आरएफपी संख्या एसएसए/निविदा/25-26/ओ एंड एम/171 (पीआर संख्या 015463 (बी एंड सी) 2025-26",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/HOUSEKEEPING.pdf"
  },
  {
    "key": "T32",
    "eventName": "tenders",
    "date": "16 अक्टूबर 2025",
    "expiryDate": "3 नवंबर 2025",
    "name": "शुद्धिपत्र (01) - राज्य खेल अकादमी, राजगीर में 03 वर्ष की अवधि के लिए निगरानी एवं सुरक्षा पर्यवेक्षक और सुरक्षा गार्ड उपलब्ध कराने हेतु सुरक्षा एजेंसी की नियुक्ति। आरएफपी संख्या: एसएसए/निविदा/25-26/सुरक्षा/170 (पीआर संख्या 015453 (बी एंड सी) 2025-26)",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/SECURITY.pdf"
  },
  {
    "key": "T31",
    "eventName": "tenders",
    "date": "26 सितंबर 2025",
    "expiryDate": "30 अक्टूबर 2025",
    "name": "राज्य खेल अकादमी, राजगीर में 03 वर्षों की अवधि के लिए व्यापक एएमसी के साथ परिसर-व्यापी वाई-फाई समाधान का डिजाइन, आपूर्ति, स्थापना, परीक्षण, कमीशनिंग और रखरखाव",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/134033379529124522.pdf"
  },
  {
    "key": "T30",
    "eventName": "tenders",
    "date": "19 सितंबर 2025",
    "expiryDate": "20 अक्टूबर 2025",
    "name": "राज्य खेल अकादमी, राजगीर में स्टेडियम, कार्यालय, छात्रावास, बागवानी और अन्य संबद्ध सुविधाओं के लिए 03 वर्ष की अवधि के लिए व्यापक हाउसकीपिंग, रखरखाव और संचालन।",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/SSA-RAJGIR-O&M-TENDER-FULL-PDF.pdf"
  },
  {
    "key": "T29",
    "eventName": "tenders",
    "date": "19 सितंबर 2025",
    "expiryDate": "17 अक्टूबर 2025",
    "name": "राज्य खेल अकादमी, राजगीर में 03 वर्ष की अवधि के लिए वॉच एंड वार्ड सुरक्षा पर्यवेक्षक और सुरक्षा गार्ड प्रदान करने के लिए सुरक्षा एजेंसी की नियुक्ति।",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "/pdf/notices/SSA-RAJGIR-SECURITY-TENDER-FULL-PDF.pdf"
  },
  {
    "key": "T28",
    "eventName": "tenders",
    "date": "17 जून 2025",
    "expiryDate": "9 जुलाई 2025",
    "name": "बिहार मशाल 2025 के लिए जिला और राज्य स्तर पर एथलीट मूल्यांकन और प्रतिभा पहचान प्रणाली और खेल प्रबंधन प्रणाली के डिजाइन, विकास, परीक्षण, कमीशनिंग, एकीकरण और रखरखाव के लिए बीएसएसए की अल्पकालीन निविदा सूचना। (आरएफपी संख्या: BSSA/Short Tender/25-26/GMS/3089 (2nd Call))",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "pdf/notices/GMS-SHORT-TENDER-FULL-DETAILS-PDF.pdf"
  },
  {
    "key": "T27",
    "eventName": "tenders",
    "date": "24 अप्रैल 2025",
    "expiryDate": "",
    "name": "शुद्धिपत्र 03 - बिहार मशाल 2025 के लिए जिला और राज्य स्तर पर एथलीट मूल्यांकन और प्रतिभा पहचान प्रणाली और खेल प्रबंधन प्रणाली के डिजाइन, डेवलपमेंट, परीक्षण, कमीशनिंग, एकीकरण और रखरखाव के लिए आरएफपी (RFP)।",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "pdf/notices/corrigendum-3-mashaal-2025.pdf"
  },
  {
    "key": "T26",
    "eventName": "tenders",
    "date": "21 अप्रैल 2025",
    "expiryDate": "",
    "name": "शुद्धिपत्र 02 - बिहार मशाल 2025 के लिए जिला और राज्य स्तर पर एथलीट मूल्यांकन और प्रतिभा पहचान प्रणाली और खेल प्रबंधन प्रणाली के डिजाइन, डेवलपमेंट, परीक्षण, कमीशनिंग, एकीकरण और रखरखाव के लिए आरएफपी (RFP)।",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "pdf/notices/Corrigendum 2. (MASHAL 2025).PDF"
  },
  {
    "key": "T25",
    "eventName": "tenders",
    "date": "18 अप्रैल 2025",
    "expiryDate": "",
    "name": "शुद्धिपत्र - बिहार मशाल 2025 के लिए जिला और राज्य स्तर पर एथलीट मूल्यांकन और प्रतिभा पहचान प्रणाली और खेल प्रबंधन प्रणाली के डिजाइन, डेवलपमेंट, परीक्षण, कमीशनिंग, एकीकरण और रखरखाव के लिए आरएफपी (RFP)।",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "pdf/notices/Corrigendum. (MASHAL 2025).PDF"
  },
  {
    "key": "T25",
    "eventName": "tenders",
    "date": "4 अप्रैल 2025",
    "expiryDate": "15 अप्रैल 2025",
    "name": "बिहार मशाल 2025 के लिए जिला और राज्य स्तर पर एथलीट मूल्यांकन और प्रतिभा पहचान प्रणाली और खेल प्रबंधन प्रणाली के डिजाइन, डेवलपमेंट, परीक्षण, कमीशनिंग, एकीकरण और रखरखाव के लिए आरएफपी (RFP)।",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "pdf/notices/133874552464725547 (1).pdf"
  },
  {
    "key": "T25",
    "eventName": "tenders",
    "date": "24 मार्च 2025",
    "expiryDate": "",
    "name": "शुद्धिपत्र - KIYG 2025, बिहार के लिए ओवरले और खेल संचालन एजेंसी की चयन हेतु संविदा (आरएफपी संख्या: BSSA/निविदा/24-25/OSOA/KIYG/1163/25)",
    "corrigendum": "",
    // "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "pdf/notices/Corrigendum Related to KIYG.PDF"
  },
  {
    "key": "T24",
    "eventName": "tenders",
    "date": "मंगलवार, 18 मार्च 2025, दोपहर 15:00 – 16:00",
    "expiryDate": "",
    "name": "KIYG 2025, बिहार के लिए ओवरले और खेल संचालन एजेंसी की चयन हेतु संविदा-प्री बिड मीटिंग। आरएफपी संख्या: BSSA/निविदा/24-25/OSOA/KIYG/1163/25",
    "corrigendum": "",
    "meetUrl": "https://meet.google.com/rox-xufc-wqf",
    "url": "https://meet.google.com/rox-xufc-wqf"
  },
  {
    "key": "T23",
    "eventName": "tenders",
    "date": "18/03/2025",
    "expiryDate": "07/04/2025",
    "name": "खेलो इंडिया यूथ गेम्स 2025 बिहार के लिए ओवरले और खेल संचालन एजेंसी की नियुक्ति के लिए निविदा",
    "corrigendum": "",
    // "meetUrl": "Online meet link : https://meet.google.com/qgi-qioq-ncj",
    "url": "img/tenders/133862326302838424_250314_134657.pdf"
  },
  {
    "key": "T22",
    "eventName": "tenders",
    "date": "शुक्रवार, 7 फरवरी 2025, अपराह्न 3:00 बजे से 5:00 बजे तक",
    "expiryDate": "",
    "name": "खेलो इंडिया यूथ गेम्स 2025 बिहार के समारोह के आयोजन हेतु एजेंसी के चयन संबंधित आरएफपी के लिए प्री-बिड बैठक - शुद्धिपत्र",
    "corrigendum": "",
    // "meetUrl": "Online meet link : https://meet.google.com/qgi-qioq-ncj",
    "url": "img/notices/KIYG  Cereomonies Corrigendum.PDF"
  },
  {
    "key": "T21",
    "eventName": "tenders",
    "date": "शुक्रवार, 7 फरवरी 2025, अपराह्न 3:00 बजे से 5:00 बजे तक",
    "expiryDate": "",
    "name": "खेलो इंडिया यूथ गेम्स 2025 बिहार के समारोह के आयोजन हेतु एजेंसी के चयन संबंधित आरएफपी के लिए प्री-बिड बैठक",
    "corrigendum": "",
    "meetUrl": "Online meet link : https://meet.google.com/qgi-qioq-ncj",
    "url": "https://meet.google.com/qgi-qioq-ncj"
  },
  {
    "key": "T20",
    "eventName": "tenders",
    "date": "29.01.2025",
    "expiryDate": "24.02.2025",
    "name": "खेलो इंडिया यूथ गेम्स 2025, बिहार के समारोहों के लिए एजेंसी के चयन से संबंधित आरएफपी",
    "corrigendum": "",
    "url": "img/notices/CeremoniesofKIYGGamesTender.PDF"
  },
  {
    "key": "T19",
    "eventName": "tenders",
    "date": "22.01.2024",
    "expiryDate": "-",
    "name": "बिहार राज्य खेल प्राधिकरण को तीन वर्षों की अवधि के लिए खेल उपकरणों की आपूर्ति हेतु एजेंसियों के पैनल से संबंधित शुद्धिपत्र 02 (पीआर संख्या 015314 (बी एंड सी) 2024-25",
    "corrigendum": "",
    "url": "img/notices/Corregnedum02RelatedtoSportsEquipmentsTender2025.PDF"
  },
  {
    "key": "T17",
    "eventName": "tenders",
    "date": "24.12.2024",
    "expiryDate": "20.01.2025",
    "name": "बिहार राज्य खेल प्राधिकरण को तीन वर्षों की अवधि के लिए खेल उपकरणों की आपूर्ति हेतु एजेंसियों के पैनल से संबंधित शुद्धिपत्र (पीआर संख्या 015314 (बी एंड सी) 2024-25",
    "corrigendum": "",
    "url": "img/notices/SportsEquipmentsCorigendum.PDF"
  },
  {
    "key": "T12",
    "eventName": "tenders",
    "date": "24.12.2024",
    "expiryDate": "20.01.2025",
    "name": "बिहार राज्य खेल प्राधिकरण के लिए खेल उपकरणों की आपूर्ति हेतु 03 वर्ष की अवधि के लिए एजेंसियों का मनोनयन",
    "corrigendum": "",
    "url": "img/notices/Empanelment of Agency for Supply Sports Equipments for BSSA.pdf"
  },
  {
    "key": "T11",
    "eventName": "tenders",
    "date": "02/11/2024,",
    "expiryDate": "05/11/2024",
    "name": "खेलो इंडिया स्मॉल सेन्टर, मोतिहारी में अभ्यास करनेवाले तलवारबाजी खेल विद्या के खिलाडियों के लिए अभ्यास हेतु विशेष उपकरणों का क्रय किये जाने हेतु कोटेशन की मांग ",
    "corrigendum": "",
    "url": "img/notices/letterno-4309.PDF"
  },
  {
    "key": "T14",
    "eventName": "tenders",
    "date": "30/10/2024,",
    "expiryDate": "03/11/2024",
    "name": "आगामी बिहार महिला एशियन हॉकी चैम्पियन ट्रॉफी 2024 खेल विद्या का आयोजन दिनांक 11-20 नवम्बर 2024 तक राजगीय, नालंदा में किया जाना है। उक्त आयोजन में कोचेज आवास, बालिका छात्रावास, स्टॉफ रूम हेतु आवश्यक सामग्रियों की आवश्यकता है। जिससे संबंधित सामानो को उपलब्ध कराने हेतु कोटेशन की मांग।",
    "corrigendum": "",
    "url": "img/notices/Tender_BSSA_Letter No 4179_30.10.24.pdf"
  },
  {
    "key": "T10",
    "eventName": "tenders",
    "date": "28/10/2024,",
    "expiryDate": "01/11/2024",
    "name": "बिहार महिला एशियन हॉकी चैम्पियनशीप ट्रॉफी 2024 के आयोजन में बिहार की भाषा एवं सस्कृति को प्रदर्शित करने एवं खिलाड़ियों के उत्साहवर्द्धन हेतु एक थीम सॉन्ग तैयार करने हेतु विभिन्न फर्मों से कोटेशन संबंधित (Letter No.: 4090)",
    "corrigendum": "",
    "url": ""
  },
  {
    "key": "T13",
    "eventName": "tenders",
    "date": "26/10/2024,",
    "expiryDate": "02/11/2024",
    "name": "बिहार महिला एशियन हॉकी चैम्पियनशीप ट्रॉफी 2024 के आयोजन में सुरक्षा व्यवस्था से संबंधित सतत् निगरानी हेतु राजगीर खेल अकादमी में NVR with Control Room Setup, Power Cable, PVC Pipe, Patch code, Segat, Cat6 Cable, Smart TV, Hdpe Pipe, Mounting Pole, HDMI Cable, UPS, Baggage Scanner से संबंधित कार्य हेतु कोटेशन की मांग।",
    "corrigendum": "",
    "url": "img/notices/Tender_BSSA_Letter No 4082_26.10.24.pdf"
  },
  {
    "key": "T12",
    "eventName": "tenders",
    "date": "25/10/2024,",
    "expiryDate": "01/11/2024",
    "name": "बिहार महिला एशियन हॉकी चैम्पियनशीप ट्रॉफी 2024 के आयोजन में सुरक्षा व्यवस्था के साथ सतत् निगरानी हेतु राजगीर खेल अकादमी में कैमरा लगाने से संबंधित कोटेशन की मांग।",
    "corrigendum": "",
    "url": "img/notices/Tender_BSSA_Letter No 4056_25.10.24.pdf"
  },
  {
    "key": "T9",
    "eventName": "tenders",
    "date": "24/10/2024,",
    "expiryDate": "30/10/2024",
    "name": " बिहार महिला एशियन हॉकी चैम्पियनशीप ट्रॉफी 2024 के आयोजन के लिए इन कार्यों 1. Digital Ads & Influencer, 2. Designing, 3. Logistics, 4. Concept (Event), 5. Concepulization, और 6. Event Management हेतु इम्पैनलड एजेंसियों से Limited Tender Enquiry में कोटेशन संबंधित (Letter No.: 4033)",
    "corrigendum": "",
    "url": ""
  },
  {
    "key": "T8",
    "eventName": "tenders",
    "date": "10/07/2024,",
    "expiryDate": "----",
    "name": " EMPANELMENT OF TRANSPORATION AGENCY(PR No -001689(B & C) 2024 - 25 से संबंधित निविदा की प्रस्तुतिकरण से संबंधित सूचना",
    "corrigendum": "",
    "url": "img/tenders/L.No. 2457 dt.10.07.2024.PDF"
  },
  {
    "key": "T8",
    "eventName": "tenders",
    "date": "05/07/2024,",
    "expiryDate": "10/07/2024",
    "name": "पाटलिपुत्र खेल परिसर कंकड़बाग पटना में मेस (कैन्टीन) संचालन हेतु प्रकाशित निविदा से संबंधित शुद्धि पत्र (Corrigendum) - 02",
    "corrigendum": "",
    "url": "img/tenders/CORRIGNEDUM_2_RELATED_TO_MESS.PDF"
  },
  {
    "key": "T7",
    "eventName": "tenders",
    "date": "02/07/2024,",
    "expiryDate": "",
    "name": "दिनांक 24/06/2024 को स्पोर्ट्स किट से संबंधित प्री-बीड बैठक में प्राप्त सुझाव एवं अन्य बिंदुओं से संबंधित शुद्वि पत्र",
    "corrigendum": "",
    "url": "img/tenders/Corrigendum Related to Sports Kit RFP.PDF"
  },
  {
    "key": "T6",
    "eventName": "tenders",
    "date": "02/07/2024,",
    "expiryDate": "",
    "name": "पाटलिपुत्र खेल परिसर छात्रावास के लिए कैटरिंग एजेंसी के चयन संबंधित निविदा के लिए शुद्धि पत्र",
    "corrigendum": "",
    "url": "img/tenders/Corrigendum 2 related to MESS.PDF"
  },
  {
    "key": "T5",
    "eventName": "tenders",
    "date": "26/06/2024,",
    "expiryDate": "",
    "name": "स्पोर्ट्स किट से संबंधित निविदा की EMD एवं TENDER FEE की राशि  से संबंधित Corrigendum (शुद्धिपत्र)",
    "corrigendum": "",
    "url": "img/tenders/Corrigendum_related_to_Sports_Ki.PDF"
  },

  {
    "key": "T4",
    "eventName": "tenders",
    "date": "25/06/2024,",
    "expiryDate": "",
    "name": "बिहार राज्य खेल प्राधिकरण के लिए खेल किट निविदाओं के लिए नई तिथि",
    "corrigendum": "",
    "url": "img/tenders/NewDateforPrebidl.PDF"
  },
  {
    "key": "T3",
    "eventName": "tenders",
    "date": "24/06/2024,",
    "expiryDate": "08/07/2024",
    "name": "बिहार राज्य खेल प्राधिकरण के लिए 03 वर्ष की अवधि के लिए खेल किट की आपूर्ति हेतु एजेंसी का चयन",
    "corrigendum": "",
    "url": "img/tenders/SPORTSKITFULLPDFFILE.pdf"
  },
  {
    "key": "T2",
    "eventName": "tenders",
    "date": "13/06/2024",
    "expiryDate": "05/07/2024",
    "name": "पाटलिपुत्र खेल परिसर छात्रावास, पटना के लिए पांच वर्षों की अवधि के लिए कैटरिंग एजेंसी के चयन हेतु निविदा",
    "corrigendum": "",
    "url": "img/tenders/MESSRPFFULLDETAILSPDFFILE.pdf"
  },
  {
    "key": "T1",
    "eventName": "tenders",
    "date": "12/06/2024",
    "expiryDate": "21/06/2024",
    "name": "EMPANELMENT OF TRANSPORATION AGENCY FOR BIHAR STATE SPORTS AUTHORITY FOR A PERIOD OF 03 YEARS",
    "corrigendum": "",
    "url": "img/tenders/TRAVEL_AGENCY_RFP_FULL_DETAILS_WORD_FILE.pdf"
  }
  // {
  //     "key": "T10",
  //     "eventName": "tenders",
  //     "date": "_",
  //     "expiryDate": "_",
  //     "name": "Corrigendum related to Travel Agency RFP",
  //     "corrigendum": "",
  //     "url": "img/tenders/Corrigendum_Travel Agency.docx"
  // },
  // {
  //     "key": "T9",
  //     "eventName": "tenders",
  //     "date": "11/01/2024",
  //     "expiryDate": "22/01/2024",
  //     "name": "EMPANELMENT OF TRANSPORATION AGENCY FOR BIHAR STATE SPORTS AUTHORITY FOR A PERIOD OF 03 YEAR",
  //     "corrigendum": "",
  //     "url": "img/tenders/RFP_FOR_Travel_Agency_for_BSSA_PDF_full_details.pdf"
  // },

  // {
  //     "key": "T8",
  //     "eventName": "tenders",
  //     "date": "15/12/2023",
  //     "expiryDate": "_____",
  //     "name": "ESTABLISHMENT OF PROJECT MONITORING UNIT FOR PROMOTING E-SPORTS OF BIHAR FOR A PERIOD OF 03 YEARS",
  //     "corrigendum": "",
  //     "url": "img/tenders/Corrigendum_E-Sports.pdf"
  // },
  // {
  //     "key": "T7",
  //     "eventName": "tenders",
  //     "date": "11/12/2023",
  //     "expiryDate": "18/12/2023",
  //     "name": "Regarding purchasing sports equipment for Center of Excellence",
  //     "corrigendum": "",
  //     "url": "img/tenders/weightliftingcenterofexcellence.pdf"
  // },
  // {
  //     "key": "T6",
  //     "eventName": "tenders",
  //     "date": "06/12/2023",
  //     "expiryDate": "15/12/2023",
  //     "name": "ESTABLISHMENT OF PROJECT MONITORING UNIT FOR PROMOTING E-SPORTS IN THE STATE OF BIHAR FOR A PERIOD OF 03 YEARS",
  //     "corrigendum": "",
  //     "url": "img/tenders/ESTABLISHMENTOFPROJECTMONITORING.pdf"
  // },
  // {
  //     "key": "T1",
  //     "eventName": "tenders",
  //     "date": "21/08/2023",
  //     "expiryDate": "11/09/2023",
  //     "name": "RFP for Selection of catering agency for Patliputra sports complex hostel, Patna for 05 years",
  //     "corrigendum": "",
  //     "url": "img/tenders/RFP for Selection of catering agency for Patliputra sports complex hostel, Patna for 05 years.pdf"
  // },
  // {
  //     "key": "T2",
  //     "eventName": "tenders",
  //     "date": "24/07/2023",
  //     "expiryDate": "24/07/2026",
  //     "name": "Letter No. 1003 Dated 24.07.2023 (4).pdf",
  //     "corrigendum": "",
  //     "url": "img/tenders/letter_number_1003_dated_24072023.pdf"
  // },
  // {
  //     "key": "T3",
  //     "eventName": "tenders",
  //     "date": "24/07/2023",
  //     "expiryDate": "24/07/2026",
  //     "name": "RFP COMPREHENSIVE HOUSEKEEPING, MAINTENANCE AND OPERATION CONTRACT (FOR 03 YEARS) FOR STADIUMS, OFFICES, HOSTELS AND OTHER ALLIED FACILITIES AT BIHAR STATE SPORTS AUTHORITY",
  //     "corrigendum": "",
  //     "url": "img/tenders/133343212303759748.pdf"
  // },
  // {
  //     "key": "T4",
  //     "eventName": "tenders",
  //     "date": "23/06/2023",
  //     "expiryDate": "23/06/2025",
  //     "name": "Corrigendum :(Pre Bid Queries) RFP for design, development, testing, commissioning, integration and maintenance of website at Bihar State Sports Authority (BSSA) for a period of 2 years",
  //     "corrigendum": "",
  //     "url": "img/tenders/TENDER.pdf"
  // },
  // {
  //     "key": "T5",
  //     "eventName": "tenders",
  //     "date": "23/06/2023",
  //     "expiryDate": "23/06/2025",
  //     "name": "Corrigendum :(Pre- bid- quarries) RFP for design, development, testing, commissioning, integration and maintenance of website at Bihar State Sports Authority (BSSA) for a period of 2 years  CamScanner 06-23-2023 13.31.09.pdf",
  //     "corrigendum": "",
  //     "url": "img/tenders/CamScanner 06-23-2023 13.31.09.pdf"
  // }
]